<div class="row">
    <div class="col-sm-4">
      <h3 class="sub-title">Answer Templates</h3></div>
    <div class="col-sm-8 text-end alert">
      <a [routerLink]="['/answer/template/create']" class="btn btn-primary" > <i class="fa fa-plus"> </i> Add Answer Template </a>
    </div>
  </div>
<div class="table-responsive-sm-12" *ngIf="answerTemplates.length>0">
    <table datatable  [dtOptions]="dtOptions" class="table table-striped display compact">
                <thead>
                <tr>
                <th><i class="fa fa-eye"></i></th>
                <th><i class="fa fa-edit"></i></th>
                <th>Name</th>
                <th>Description</th>
                </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let answerTemplate of answerTemplates;">
                    <td>
                      <a [routerLink]="['/answer/template/show/',answerTemplate.id]" >
                        <i class="fa fa-eye"></i>
                      </a>

                    </td>
                    <td>
                      <a [routerLink]="['/answer/template/edit/',answerTemplate.id]" >
                        <i class="fa fa-edit"></i>
                      </a>
                    </td>
                    <td>{{answerTemplate.name}}</td>
                    <td width="80%">{{answerTemplate.description}}</td>

                  </tr>
                </tbody>

    </table>
    </div>
